<template>
  <el-dialog
    :title="`理货单明细`"
    :visible.sync="visible"
    width="1030px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <div class="dialog-print-wrap">
      <div
        ref="print"
        class="print-wrap">
        <el-form
          :inline="true"
          label-width="60px">
          <el-divider>理货明细【{{ outInfo.createTime | dateformat() }}】</el-divider>
          <el-form-item label="单号：">{{ outInfo.code }}</el-form-item>
          <el-form-item label="仓库：">{{ outInfo.warehouseNo | warehouseName() }}</el-form-item>
          <el-form-item
            label-width="70px"
            label="创建人：">{{ outInfo.createName }}</el-form-item>
        </el-form>
        <el-table
          v-loading="loading"
          show-summary
          :summary-method="getSummaries"
          border
          :data="outInfo.detailList">
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName"></el-table-column>
          <el-table-column
            label="商品编号"
            width="200"
            :resizable="false"
            prop="skuCode">
          </el-table-column>
          <el-table-column
            label="数量"
            width="200"
            :resizable="false"
            prop="num">
            <template slot-scope="scope">{{ scope.row.num }} {{ scope.row.measureUnit | measureUnitName() }}</template>
          </el-table-column>
        </el-table>
        <el-divider>发货明细（共{{ orderCount }}个订单，{{ list.length }}条发货记录）</el-divider>
        <el-table
          v-loading="loading1"
          border
          :row-class-name="tableRowClassName"
          :data="list">
          <!-- <el-table-column
          :resizable="false"
          label="发货单号"
          width="145"
          prop="code"></el-table-column> -->
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="订单号"
            width="160"
            prop="bizOrderCode">
            <template slot-scope="{row}">
              <div
                v-for="(item, index) in row.bizOrderCode"
                :key="index">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            min-width="280">
            <template slot-scope="{row}">
              <div>
                <span>{{ row.sendOrderList.receiverName }}</span>
                <span v-if="row.sendOrderList.receiverMobile">
                  <i
                    style="margin-left: 5px"
                    class="el-icon-mobile-phone"></i>{{ row.sendOrderList.receiverMobile }}
                </span>
                <span v-if="row.sendOrderList.receiverTel">
                  <i
                    style="margin-left: 5px"
                    class="el-icon-phone-outline"></i>{{ row.sendOrderList.receiverTel }}
                </span>
              </div>
              <div>{{ row.sendOrderList.receiverProvince }}{{ row.sendOrderList.receiverCity }}{{ row.sendOrderList.receiverDistrict }}-{{ row.sendOrderList.receiverAddress }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="订单来源"
            width="85"
            :resizable="false">
            <template slot-scope="{row}">
              {{ row.orderSource | sourceName() }}
            </template>
          </el-table-column>
          <el-table-column
            label="发货状态"
            :resizable="false"
            width="90"
            prop="status">
            <template slot-scope="{row}">
              <span :style="{color: row.status === 9 ? 'red': '#606266'}">{{ row.status | outStatusName() }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
          label="物流模板"
          min-width="140"
          prop="packageNum">
          <template slot-scope="{row}">
            {{ row.expressCode | expressName() }}
          </template>
        </el-table-column> -->
          <!-- <el-table-column
          label="发货方式"
          width="70"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.transType | transTypeName() }}
          </template>
        </el-table-column> -->
          <el-table-column
            label="明细"
            width="310"
            :resizable="false">
            <template slot-scope="{row}">
              <el-row
                v-for="item in row.detailList"
                :key="item.id"
                :gutter="10">
                <el-col :span="16">{{ item.skuName }}</el-col>
                <el-col :span="8">数量：{{ item.num }}{{ item.measureUnit | measureUnitName() }}</el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        :loading="loading || loading1"
        @click="printOrder">打印</el-button>
      <el-button
        :loading="loading || loading1"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { MeasureUnitName } from '../../../utils/index'
// import CateEditModal from './cate-edit-modal.vue'
import _ from 'lodash'
export default {
  name: 'PrintModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      loading1: false,
      outInfo: {},
      visible: false,
      list: [],
      totalCount: '',
      orderCount: 0,
      config: {
        tallyOrderId: null,
        tallyOrderCode: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.status === 9) {
        return 'warning-row-cus'
      }
      if (row.status === 2) {
        return 'success-row-cus'
      }
      return ''
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = ''
          return
        }
        if (index === 2) {
          sums[index] = this.totalCount
          return
        }
      })
      return sums
    },
    printOrder() {
      if (this.outInfo.printStatus === 0) {
        this.loading = true
        this.$store.dispatch('outstock/tallyorderprint', {
          payload: {
            tallyOrderId: this.outInfo.id
          },
          success: () => {
            this.callback && this.callback()
            this.loading = false
          },
          fail: () => {
            this.loading = false
          }
        })
      }
      this.$print(this.$refs.print, {})
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {}
      this.config.tallyOrderId = null
      this.config.tallyOrderCode = null
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('outstock/tallyorderdetail', {
        payload: {
          tallyOrderId: this.config.tallyOrderId
        },
        success: res => {
          this.loading = false
          console.log(_.groupBy(res.data.data.detailList, 'skuCode'))
          const object = _.groupBy(res.data.data.detailList, 'skuCode')
          const list = []
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key)) {
              const element = object[key]
              list.push({
                skuName: element[0].skuName,
                skuCode: element[0].skuCode,
                measureUnit: element[0].measureUnit,
                num: element.map(i => i.num).reduce((total, cur) => total + cur, 0)
              })
            }
          }
          this.doTotal(list)
          this.outInfo = {
            ...res.data.data,
            detailList: list
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    doTotal(list) {
      const object = _.groupBy(list, 'measureUnit')
      const result = []
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const element = object[key]
          result.push((element.map(i => i.num).reduce((total, cur) => total + cur, 0)) + '' + (MeasureUnitName.find(i => i.value === +key) || {}).label)
        }
      }
      console.log(result)
      this.totalCount = result.join(',')
    },
    fetchList1() {
      this.loading1 = true
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          tallyOrderCode: this.config.tallyOrderCode,
          pageNum: 1,
          pageSize: 100000,
          excludePrintTemplate: true
        },
        success: (res) => {
          // this.list = res.data.data.records.map(i => {
          //   return {
          //     ...i,
          //     sendOrderList: i.sendOrderList ? i.sendOrderList[0] : {}
          //   }
          // })
          const records = JSON.parse(JSON.stringify(res.data.data.records))
          const newList = []
          const newMap = {}
          records.forEach(i => {
            if (i.combinedDeliveryNumber === 0 || !i.combinedDeliveryNumber) {
              newList.push({
                bizOrderCode: [i.bizOrderCode],
                sendOrderList: i.sendOrderList ? i.sendOrderList[0] : {},
                orderSource: i.orderSource,
                detailList: i.detailList,
                status: i.status
              })
            } else {
              const mapItem = newMap[i.combinedDeliveryNumber]
              if (mapItem === undefined) {
                newList.push({
                  bizOrderCode: [i.bizOrderCode],
                  sendOrderList: i.sendOrderList ? i.sendOrderList[0] : {},
                  orderSource: i.orderSource,
                  detailList: i.detailList,
                  status: i.status
                })
                newMap[i.combinedDeliveryNumber] = newList.length - 1
              } else {
                const index = newMap[i.combinedDeliveryNumber]
                const listItem = newList[index]
                if (listItem.bizOrderCode.indexOf(i.bizOrderCode) === -1) {
                  listItem.bizOrderCode.push(i.bizOrderCode)
                }
                const skuObj = _.groupBy([...listItem.detailList, ...i.detailList], 'skuId')
                const skuList = []
                for (const key in skuObj) {
                  const skuItemList = skuObj[key]
                  skuList.push({
                    ...skuItemList[0],
                    num: skuItemList.map(i => i.num).reduce((total, cur) => total + cur, 0)
                  })
                }
                listItem.detailList = skuList
                newList[index] = listItem
              }
            }
          })
          this.$set(this, 'list', newList)
          // const list0 = records.filter(i => i.combinedDeliveryNumber === 0).map(i => {
          //   return {
          //     bizOrderCode: [i.bizOrderCode],
          //     sendOrderList: i.sendOrderList ? i.sendOrderList[0] : {},
          //     orderSource: i.orderSource,
          //     detailList: i.detailList,
          //     status: i.status
          //   }
          // })
          // const listObj = _.groupBy(records.filter(i => i.combinedDeliveryNumber > 0), 'combinedDeliveryNumber')
          // console.log(listObj)
          // const list = []
          // for (const key in listObj) {
          //   const itemList = listObj[key]
          //   const bizOrderCode = []
          //   const map = {}
          //   itemList.forEach(s => {
          //     bizOrderCode.push(s.bizOrderCode)
          //     s.detailList.forEach(m => {
          //       if (map[m.skuId]) {
          //         const mapItem = map[m.skuId]
          //         mapItem.num = mapItem.num + m.num
          //       } else {
          //         map[m.skuId] = m
          //       }
          //     })
          //   })
          //   const detailList = Object.values(map)
          //   list.push({
          //     bizOrderCode: bizOrderCode,
          //     sendOrderList: itemList[0].sendOrderList ? itemList[0].sendOrderList[0] : {},
          //     orderSource: itemList[0].orderSource,
          //     status: itemList[0].status,
          //     detailList: detailList
          //   })
          //   console.log(list)
          // }
          // list.push(...list0)
          this.orderCount = Object.keys(_.groupBy(res.data.data.records, 'bizOrderCode')).length
          this.loading1 = false
        },
        fail: () => {
          this.loading1 = false
        }
      })
    },
    fetch(row) {
      this.config.tallyOrderId = row.id
      this.config.tallyOrderCode = row.code
      this.toggleModal(true)
      this.fetchList()
      this.fetchList1()
    }
  }
}
</script>
<style lang="stylus" scoped>
.dialog-print-wrap {
  max-height 800px
  overflow-y auto
}
.print-wrap {
  // padding: 12px;
  // width: 400px;

  .el-form-item {
    margin-right: 20px;
    // margin-bottom: 0;
  }
}
</style>
